module.exports = __webpack_public_path__ + "static/media/mm-logo.5ee9f212.png";